export default __webpack_public_path__ + "static/media/techtop-logo.dc072fce.webp";